import { computed, Ref, ref, ToRef } from 'vue'
import { areSame } from '@/utils/comparison'
import {
  getBooleanStorageReader,
  getEnumStorageReader,
  getJsonStorageReader,
  getStringStorageReader,
  Storage,
} from './reader'

const variablesMap: Record<string, Ref<any>> = {}

function getComputedFromStorageReader<R, W>(
  key: string,
  storage: Storage<R, W>
) {
  // Keep instances with the same storage Key synced

  const variable = (variablesMap[key] ?? ref(storage.read())) as ToRef<R>

  variablesMap[key] = variable

  return computed({
    get(): R {
      return variable.value
    },
    set(value?: W) {
      if (areSame(value, variable.value)) {
        return
      }

      storage.set(value)

      variable.value = storage.read()
    },
  })
}

export function getStringStorageComputed(key: string) {
  return getComputedFromStorageReader(key, getStringStorageReader(key))
}

export function getBooleanStorageComputed(key: string, defaultValue: boolean) {
  return getComputedFromStorageReader(
    key,
    getBooleanStorageReader(key, defaultValue)
  )
}

export function getEnumStorageComputed<
  O extends string,
  D extends O | undefined,
>(key: string, options: readonly O[], defaultValue: D) {
  return getComputedFromStorageReader(
    key,
    getEnumStorageReader(key, options, defaultValue)
  )
}

export function getJsonStorageComputed(key: string) {
  return getComputedFromStorageReader(key, getJsonStorageReader(key))
}
